module.exports = __webpack_public_path__ + "img/warning-big.06c10c06.svg";